var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSticker33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_5890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6096 83.7334C68.1435 83.7334 85.6001 66.2768 85.6001 44.7429C85.6001 23.2091 68.1435 5.75244 46.6096 5.75244C25.0758 5.75244 7.61914 23.2091 7.61914 44.7429C7.61914 66.2768 25.0758 83.7334 46.6096 83.7334Z",
    fill: "#C7BBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5187 35.4265L33.2969 20.8647H41.4714L38.3115 33.0114H40.6471L29.3813 50.4854L32.2665 35.4265H29.5187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2814 35.4265L55.0596 20.8647H63.2341L60.0742 33.0114H62.4098L51.144 50.4854L54.0292 35.4265H51.2814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_5890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker33);
export default __webpack_public_path__ + "static/media/sticker33.0d8479ff537439b3fd9e01037b9fee79.svg";
export { ForwardRef as ReactComponent };